
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useGetAgentById, useCreateAgent, useUpdateAgent } from '@/hooks/use-agent';
import { Loader2 } from 'lucide-react';
import AgentFormComponent from '@/components/agents/AgentForm';
import { Button } from '@/components/ui/button';

const AgentForm = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const isEditing = !!id;
  
  const { data: agent, isLoading } = useGetAgentById(id || '');
  const createAgent = useCreateAgent();
  const updateAgent = useUpdateAgent();

  const handleSubmit = async (data: any) => {
    try {
      if (isEditing && id) {
        await updateAgent.mutateAsync({ id, data });
      } else {
        await createAgent.mutateAsync(data);
      }
      navigate('/agents');
    } catch (error) {
      console.error('Error saving agent:', error);
    }
  };

  return (
    <Layout>
      <div className="container mx-auto py-8">
        <div className="mb-6">
          <Button variant="outline" onClick={() => navigate('/agents')} className="mb-4">
            Back to Agents
          </Button>
          <h1 className="text-2xl font-bold">
            {isEditing ? 'Edit Agent' : 'Add Agent'}
          </h1>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>{isEditing ? 'Edit Agent Details' : 'Agent Information'}</CardTitle>
          </CardHeader>
          <CardContent>
            {isEditing && isLoading ? (
              <div className="flex justify-center py-8">
                <Loader2 className="h-8 w-8 animate-spin text-primary" />
              </div>
            ) : (
              <AgentFormComponent 
                initialData={agent} 
                onSubmit={handleSubmit} 
                isSubmitting={createAgent.isPending || updateAgent.isPending}
              />
            )}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default AgentForm;
